import Button from '@/components/ui/buttons/Button';
import ErrorList from '@/components/ui/forms/ErrorList';

import AbsencesFooter from '../parts/AbsencesFooter';
import AbsencesFooterContent from '../parts/AbsencesFooterContent';

import styles from './AbsencesConfirmFooter.module.scss';

interface Props {
  onSubmit: () => void;
  onBack: () => void;
  buttonDisabled?: boolean;
  errors?: string[] | null;
}

const AbsencesConfirmFooter: React.FC<Props> = ({
  onSubmit,
  onBack,
  buttonDisabled = false,
  errors = [],
}) => (
  <AbsencesFooter>
    <AbsencesFooterContent
      note="この連絡は学校内のすべての教員が閲覧できます。"
      description="※生徒の出欠日数は、この連絡では確定しません。出欠日数のカウントは実際の在校状況が優先されるのでご了承ください。"
    />
    {errors && <ErrorList errors={errors} className={styles.errorList} />}
    <div className={styles.buttons}>
      <Button
        color="primary"
        size="l"
        onClick={onSubmit}
        disabled={buttonDisabled}
        className={styles.button}
      >
        送信
      </Button>
      <Button color="link" size="l" onClick={onBack} className={styles.button}>
        &lt; 戻る
      </Button>
    </div>
  </AbsencesFooter>
);

export default AbsencesConfirmFooter;
